import { useAtomValue } from 'jotai';
import { Typography } from '@statsbomb/kitbag-components';
import { playerInfoAtom } from '@/atoms/player/info';
import { usePlayerPositionsInfo } from '@/hooks/usePlayerPositionsInfo';
import { FlagIcon } from '@/components/icons/FlagIcon';
import { useTranslation } from 'react-i18next';

const DotSeparator = () => <span className="h-1 w-1 bg-canvas-primary-main rounded-full" />;

export const PlayerPreviewInfo = () => {
  const { t } = useTranslation('playerInfo');
  const playerInfo = useAtomValue(playerInfoAtom);
  const playerPositions = usePlayerPositionsInfo();
  const countryCode = playerInfo?.nationalityAreaCode;
  const yearOfBirth = playerInfo?.dateOfBirth?.slice(0, 4);
  const age = playerInfo?.age;
  const height = playerInfo?.height;

  return (
    <Typography as="div" variant="bodySmall" className="flex items-center gap-2 flex-wrap !text-ink-primary-main/80">
      {countryCode && <FlagIcon countryCode={countryCode} />}
      <span>{playerPositions}</span>
      <DotSeparator />
      {yearOfBirth && age && <span>{`${yearOfBirth} (${age})`}</span>}
      <DotSeparator />
      {height && <span>{t('centimetres', { count: height })}</span>}
    </Typography>
  );
};
